import {
  alpha,
  Box,
  MenuItem,
  Radio,
  Typography,
  useTheme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { CanalInterface } from 'store/reducers/canais';
import getIconTipoCanal from 'utils/getIconTipoCanal';

const useStyles = makeStyles(({ palette, spacing }) => ({
  menuItem: {
    marginBottom: spacing(1),
    gap: spacing(1),
    border: `1px solid ${palette.divider}`,
    transition: 'all 0.2s ease-in-out',
    borderRadius: spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
    '&.Mui-selected': {
      backgroundColor: alpha(palette.primary.main, 0.05),
      border: `1px solid ${palette.primary.main}`,
      '&:hover': {
        backgroundColor: alpha(palette.primary.main, 0.1),
      },
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },
  itemSubtitle: {
    color: palette.text.secondary,
  },
}));

interface CanalMenuItemProps {
  canal: CanalInterface;
  isSelected: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export default function CanalMenuItem({
  canal,
  isSelected,
  disabled = false,
  onClick,
}: CanalMenuItemProps) {
  const classes = useStyles();
  const { palette } = useTheme();

  return (
    <MenuItem
      onClick={onClick}
      selected={isSelected}
      disabled={disabled}
      className={classes.menuItem}
      style={{
        backgroundColor: canal.isCanalOnline
          ? alpha(palette.success.main, 0.1)
          : alpha(palette.error.main, 0.1),
      }}
    >
      <Box display="flex" alignItems="center">
        {getIconTipoCanal({
          tipoCanal: canal.tipoCanal,
          size: 20,
          isModoHibrido: canal.isModoHibrido,
        })}
      </Box>
      <Box className={classes.textContainer}>
        <Typography variant="body2" noWrap>
          {canal.nome}
        </Typography>
        <Typography variant="caption" className={classes.itemSubtitle} noWrap>
          {canal.contato}
        </Typography>
      </Box>
      <Radio
        disabled={disabled}
        disableFocusRipple
        disableTouchRipple
        checked={isSelected}
        color="primary"
        size="small"
      />
    </MenuItem>
  );
}
